<template>
  <footer class="spotlight-footer bc-black">

    <!-- Related articles -->
    <div v-if="relatedArticles.length" class="related-section ta-c d-f fd-c g">
      <p class="related-label mute tt-up">Related</p>

      <div class="related-grid">
        <!-- <router-link
          v-for="article in relatedArticles"
          :key="article.slug"
          :to="`/spotlights/${article.slug}`"
          class="related-card"
        > -->
        <router-link
          v-for="article in relatedArticles"
          :key="article.slug"
          :to="`#`"
          class="related-card"
        >
          <div class="related-card-img">
            <img
              v-if="article.profileImage && article.profileImage.url"
              :src="article.profileImage.url"
              :alt="article.artistName"
            />
          </div>
          <div class="related-card-content">
            <div class="related-card-top d-f jc-sb ai-c">
              <span class="mute font-small2 tt-up">Spotlight</span>
              <span class="mute font-small2 tt-up">{{ formatDate(article.publishedAt) }}</span>
            </div>
            <div class="related-card-bottom">
              <p class="related-artist-name tt-up">{{ article.artistName }}</p>
              <p class="mute font-small2 tt-up">{{ genreString(article.genres) }}</p>
            </div>
          </div>
        </router-link>
      </div>

      <!-- <router-link to="/spotlights" class="see-all tt-up underline mute text-link">See All</router-link> -->
       <p
       @click="$store.dispatch('togglePopMess')" 
       class="see-all tt-up underline mute text-link">See All</p>
    </div>

    <!-- Legal bar -->
    <div class="legal-bar ta-c tt-up font-small">
      <a href="#" class="mute" @click.prevent="scrollToTop">Scroll to top</a>
      <div class="d-f jc-c f-wrap g m-t-sm">
        <router-link to="/legal/terms" class="mute">Terms</router-link>
        <router-link to="/legal/privacy" class="mute">Privacy</router-link>
        <router-link to="/legal/cookies" class="mute">Cookies</router-link>
        <a class="mute" href="javascript:revisitCkyConsent()">Cookie Consent</a>
      </div>
      <p class="mute m-t-sm">© 2026 Meshin AB</p>
    </div>

  </footer>
</template>

<script>
import allArticles from './articles.json'

export default {
  name: 'SpotlightFooter',
  props: {
    currentSlug: {
      type: String,
      default: '',
    },
  },
  computed: {
    relatedArticles() {
      return Object.values(allArticles)
        .filter(a => a.slug !== this.currentSlug)
        .slice(0, 2)
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr + 'T00:00:00')
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).toUpperCase()
    },
    genreString(genres) {
      if (!genres || !genres.length) return ''
      return genres.map(g => g.charAt(0).toUpperCase() + g.slice(1)).join(' / ')
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.spotlight-footer {
  width: 100%;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

/* Related section */
.related-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $mg-desktop-2xl $mg-desktop-lg $mg-desktop-xl;

  @media #{$mobile} {
    padding: $mg-desktop-xl $mg-desktop $mg-desktop-lg;
  }
}

.related-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: $mg-desktop-xl;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: $line-color-dark;
  }

  @media #{$mobile} {
    grid-template-columns: 1fr;
    gap: $mg-desktop;

    &::after {
      display: none;
    }
  }
}

.related-card {
  display: flex;
  align-items: stretch;
  border: 1px solid $line-color-dark;
  text-decoration: none;
  transition: border-color 0.2s;
  padding: $mg-desktop-lg;
  gap: $mg-desktop-lg;

  &:hover {
    background-color: rgba(255,255,255,0.1);
    border-color: $line-color;
    text-decoration: none;
  }
  @media #{$mobile} {
    padding: $mg-desktop;
    gap: $mg-desktop;
  }
}

.related-card-img {
  width: 180px;
  height: 180px;
  overflow: hidden;
  background-color: $card-bg-color;
  border: 1px solid $line-color-dark;

  @media #{$mobile} {
    width: 80px;
    height: 80px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.related-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
}

.related-card-top {
  width: 100%;
}

.related-artist-name {
  font-size: $h3-d;
  color: $text-color;
  margin: 0;
  @media #{$mobile} {
    font-size: $h3-m;
  }
}

/* Legal bar */
.legal-bar {
  padding: $mg-desktop-lg;

  @media #{$mobile} {
    padding: $mg-desktop-lg $mg-desktop;
  }
}
</style>
